import React from 'react';
import PropTypes from 'prop-types';

import SVGIcon from './SVGIcon';
import { formatNumber } from '../utilities/helpers';

const HomeSummary = props => (
  <div className="HomeSummary">
    <div className="content-card">
      <SVGIcon icon="pins" />
      <p>
        <b>
          {
            props.eventsCount !== null && props.eventsCount !== undefined
              ? formatNumber(props.eventsCount)
              : 0
          }
        </b> location records
        <br />
        collected &amp; enriched
      </p>
    </div>
    <div className="content-card">
      <SVGIcon icon="device" />
      <p>
        <b>
        {
            props.devicesCount !== null && props.devicesCount !== undefined
              ? formatNumber(props.devicesCount)
              : 0
        }
        </b> unique devices
      </p>
    </div>
    <div className="content-card">
      <SVGIcon icon="position-marker" />
      <p>
        <b>
        {
            props.poiCountData.poisCount !== null && props.poiCountData.poisCount !== undefined
              ? formatNumber(props.poiCountData.poisCount)
              : 0
        }
        </b> Points of Interest
        <br />
        observed across a network of <b>
        {
            props.poiCountData.poisTotalCount !== null && props.poiCountData.poisTotalCount !== undefined
              ? formatNumber(props.poiCountData.poisTotalCount)
              : 0
        }
        </b>
      </p>
    </div>
  </div>
);

HomeSummary.propTypes = {
  eventsCount: PropTypes.number,
  devicesCount: PropTypes.number,
  poisCount: PropTypes.number,
  poisTotalCount: PropTypes.number,
  clientName: PropTypes.string.isRequired,
};

HomeSummary.defaultProps = {
  eventsCount: undefined,
  devicesCount: undefined,
  poisCount: undefined,
  poisTotalCount: undefined,
};

export default HomeSummary;
